import React from "react";
import SvgIcon, { ISvgIconProps } from "../SvgIcon/SvgIcon";

export default function createSvgIcon(
  path: React.ReactNode,
  displayName: string,
  attr?: { viewBox: string, width?: string, height?: string }
) {
  const Component = (props: ISvgIconProps, ref: any) => (
    <SvgIcon data-testid={`${displayName}Icon`} ref={ref} {...attr} {...props}>
      {path}
    </SvgIcon>
  );
  Component.displayName = `${displayName}Icon`;

  return React.forwardRef<any, ISvgIconProps>(Component);
}
